import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import apiFetch from '../../utils/api';
import './LoginPage.css';

const LoginPage = () => {
  const [credentials, setCredentials] = useState({ email: '', password: '' });
  const [status, setStatus] = useState({ loading: false, error: '' });
  
  const navigate = useNavigate();
  const { login, isAuthenticated, isAdmin } = useAuth();

  // If already logged in, redirect
  React.useEffect(() => {
    if (isAuthenticated) {
      navigate(isAdmin ? '/dashboard/admin/overview' : '/dashboard', { replace: true });
    }
  }, [isAuthenticated, isAdmin, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, error: '' });

    try {
      const response = await apiFetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(credentials),
      });

      const data = await response.json();

      if (data.success) {
        login(data.token, data.user);
        navigate(data.route);
      } else {
        setStatus({ 
          loading: false, 
          error: data.message || 'Access Denied. Please check your credentials.' 
        });
      }
    } catch (err) {
      setStatus({ 
        loading: false, 
        error: 'Server error. Please try again later.' 
      });
    }
  };

  return (
    <div className="dynamic-viewport">
      <div className="dynamic-glass-container">
        <form className="dynamic-login-form" onSubmit={handleLogin}>
          <header className="dynamic-form-header">
            <h1 className="dynamic-brand-logo">Welcome to Alpha Wealth</h1>
            <p className="dynamic-brand-tagline">Alpha Wealth Pakistan</p>
            
            <div className="mission-card-wrapper">
              <div className="mission-card-inner">
                <span className="mission-card-icon">✨</span>
                <p className="description-urdu-modern">
                  Alpha Wealth پاکستان کی ایک جدید ڈیجیٹل سیلز اور مارکیٹنگ کمپنی ہے جو افراد کو اشتہارات دیکھ کر کمائی کرنے کا موقع فراہم کرتی ہے۔ اس کے ساتھ Direct اور Indirect ریفرلز کے ذریعے کمیشن اور ریوارڈز حاصل کرنے کا ایک شفاف، قابل اعتماد اور منظم نظام موجود ہے۔
                </p>
              </div>
            </div>

            <div className="form-divider">
              <span className="divider-text">System Access</span>
            </div>
          </header>

          <div className="dynamic-input-wrapper">
            <input
              type="email"
              name="email"
              className="dynamic-input-field"
              placeholder=" "
              autoComplete="email"
              onChange={handleChange}
              required
            />
            <label className="dynamic-floating-label">Email Address</label>
          </div>

          <div className="dynamic-input-wrapper">
            <input
              type="password"
              name="password"
              className="dynamic-input-field"
              placeholder=" "
              onChange={handleChange}
              required
            />
            <label className="dynamic-floating-label">Password</label>
          </div>

          {status.error && <div className="dynamic-error-banner">{status.error}</div>}

          <button 
            type="submit" 
            className={`dynamic-submit-btn ${status.loading ? 'is-loading' : ''}`}
            disabled={status.loading}
          >
            {status.loading ? <span className="dynamic-spinner"></span> : "Enter System"}
          </button>

          <footer className="dynamic-form-footer">
            <p className="dynamic-footer-text">Secure Encrypted Session</p>
          </footer>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;